import { useLocation } from 'react-router';

function useIsDebugView() {
  const { pathname } = useLocation();
  const lowerCasedPathName = pathname.toLowerCase();
  return lowerCasedPathName.includes('debug')
}

export default useIsDebugView;
